/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Context_read = {
    id?: string;
    type?: Context_read.type;
    name?: string;
};
export namespace Context_read {
    export enum type {
        CITY = 'city',
        REGION = 'region',
        COUNTRY = 'country',
        VOIVODESHIP = 'voivodeship',
        CATEGORY = 'category',
    }
}

